(ns com.theplantscape.local-store.diagram-db
  (:require [datascript.core :as d]
            [com.theplantscape.local-store.core-db :refer [diag schema]]
            [com.theplantscape.local-store.utils :refer [namespace-map]]
            #?(:clj [com.theplantscape.specs.ensemble :refer [load-plants-path]])
            [com.theplantscape.conversions.ensemble  :refer [distance]])
  #?(:cljs (:require-macros [com.theplantscape.specs.ensemble :refer [load-plants-path]])))

(defonce plant-list (load-plants-path "./resources/plants/"))

(def drop-ns (comp keyword name))

(defn insert-objects [objects]
  (prn objects)
  (d/transact! diag objects))

(defn insert-plant [plant]
  (d/transact! diag [plant]))

(defn insert-diagram-data []
  (d/transact!
   diag
   [{:layers :canopy} {:layers :sub-canopy}
    {:layers :shrub} {:layers :herbaceous}
    {:layers :ground} {:layer :underground}
    {:layer :climbing}
    {:permaculture {:layers #{:canopy :sub-canopy :shrub :herbaceous :ground :underground :climbing}}}
    {:plant.lifecycle/name :annual}
    {:plant.lifecycle/name :perenial}
    {:plant.lifecycle/name :biennial}
    {:plant.lifecycle/name :tender-perenial}])
  (d/transact! diag plant-list))

(defonce inital-data (insert-diagram-data))

(defn reset-database []
  (d/reset-conn! diag (d/empty-db schema))
  (insert-diagram-data))

(def keyword-value
  #{:plant/type
    :plant/common-name
    :layer
    :layers
    :restore
    :plant.lifecycle/name
    ;;:permaculture
    :diagram.object/type})

(defn keywordize-datoms [datom]
  (if (contains? keyword-value (second datom))
    (update datom 2 keyword)
    datom))

(defn load-database
  ([datoms] (load-database datoms false))
  ([datoms debug]
   (d/reset-conn!
    diag
    @(d/conn-from-datoms
      (->> datoms
           (mapv (fn [datom]
                   (apply d/datom (keywordize-datoms (update datom 1 keyword)))))
           (filter #(not= (second %) "db")))
      schema))))

(defn reset []
  (d/reset-conn! diag (d/empty-db schema))
  (insert-diagram-data))

(defn fetch-entity-by-attribute [eid attr ]
  (d/q  '{:find [(pull ?eid [*])]
         :in [$ ?eid ?attr]
         :where [[?eid ?attr _]]} @diag eid attr)
  
  )

(defn update-entity [eid attr value]
  (prn (str "update entity " eid attr value))
  (d/transact! diag [{:db/id eid attr value}]))

(comment
  (d/entity @diag 58)
  (select-structure :structure)
  (select-structure :area)
  (select-structure :patch)
  ;; => #{{:entity-id 58,
  ;;       :points
  ;;       [[5.2 24.6]
  ;;        [20.400000000000002 25.3]
  ;;        [19.400000000000002 75.2]
  ;;        [3 74.60000000000001]],
  ;;       :colour "",
  ;;       :svg-filter "ground",
  ;;       :label "",
  ;;       :plant-entity-id 14}
  ;;      {:entity-id 53,
  ;;       :points
  ;;       [[27.3 25.3] [42 25.3] [41.1 76] [23.400000000000002 75.3]],
  ;;       :colour "",
  ;;       :svg-filter "no-pattern",
  ;;       :label "",
  ;;       :plant-entity-id 14}
  ;;      {:entity-id 49,
  ;;       :points
  ;;       [[71.5 76]
  ;;        [87.10000000000001 77.10000000000001]
  ;;        [87.7 24.400000000000002]
  ;;        [74.60000000000001 24.200000000000003]],
  ;;       :colour "",
  ;;       :svg-filter "canopy",
  ;;       :label "",
  ;;       :plant-entity-id 14}
  ;;      {:entity-id 47,
  ;;       :points
  ;;       [[50 76.5]
  ;;        [50.2 25.400000000000002]
  ;;        [64.7 24.900000000000002]
  ;;        [64 76.3]],
  ;;       :colour "",
  ;;       :svg-filter "canopy",
  ;;       :label "",
  ;;       :plant-entity-id 14}}

  (d/pull @diag '[*] 53)
  ;; => {:db/id 53,
  ;;     :diagram.object/plant-entity-id 14,
  ;;     :diagram.object/position
  ;;     [[27.3 25.3] [42 25.3] [41.1 76] [23.400000000000002 75.3]],
  ;;     :diagram.object/type :patch}
  (d/pull @diag '[*] 47)
  ;; => {:db/id 47,
  ;;     :diagram.object/plant-entity-id 14,
  ;;     :diagram.object/plant-uuid "12f796b5-6796-4eeb-ad2b-bf145ca18bfa",
  ;;     :diagram.object/position
  ;;     [[50 76.5]
  ;;      [50.2 25.400000000000002]
  ;;      [64.7 24.900000000000002]
  ;;      [64 76.3]],
  ;;     :diagram.object/svg-filter "canopy",
  ;;     :diagram.object/type :patch}
  (d/pull @diag '[*] 62)
  ;; => {:db/id 62,
  ;;     :diagram.object/plant-entity-id 14,
  ;;     :diagram.object/position
  ;;     [[2.2 26.1]
  ;;      [20.700000000000003 28.6]
  ;;      [13.200000000000001 72.60000000000001]
  ;;      [-8.8 68.60000000000001]],
  ;;     :diagram.object/type :patch}
  (d/pull @diag '[*] 68)
  (d/pull @diag '[*] 47)
  (d/pull @diag '[*] 49)
  (d/pull @diag '[*] 58)
  (d/pull @diag '[*] 49)
  (d/pull @diag '[*] 53)
  (d/pull @diag '[*] 62)
  (d/pull @diag '[*] 68)
  (d/pull @diag '[*] 18)
  (fetch-entity-by-attribute 58 :plant-entity-id)
  (update-entity 58 :plant-entity-id 14)
  (update-entity 53 :diagram.object/plant-entity-id 14)
  (update-entity 53 :diagram.object/svg-filter "canopy")
  )

(defn set-label [eid label]
  (update-entity eid :diagram.object/label label))

(defn set-colour [eid colour]
  (prn "set colour " eid " " colour)
  (update-entity eid :diagram.object/colour colour))

(def query-plants
  {:find ['?e '?name '?type '?season '?sci-name]
   :keys '[id common-name type season scientific-name]
   :where [['?e :plant/common-name '?name]
           ['?e :plant/scientific-name '?sci-name]
           ['(get-else $ ?e :plant.season/fruiting :nil) '?season]
           ['?e :plant/type '?type]]})

(defn plants []
  (d/q query-plants @diag))

(defn db-search-filter [{:keys [search type]}]
  (cond-> query-plants
    search
    (update-in  [:where] #(conj % [`(~'re-find ~search ~'?name)]))
    type
    (update-in  [:where] #(conj % ['?e :plant/type type]))))

(defn search->plants [search]
  (d/q (db-search-filter search) @diag))

(defn layers []
  (d/q  {:find [['?layer '...]]
         :where [['?e :layers '?layer]]} @diag))

(defn stats []
  (d/q  {:find ['?type '(count ?e)]
         :keys [type count]
         :where [['?e :diagram.object/type '?type]
                 ['?e :diagram.object/position '?pos]]} @diag))

(defn diagrams []
  [(->>  (d/q {:find ['?title '?description]
               :keys '[title description]
               :where [['?e :diagram.settings/title '?title]
                       ['(get-else $ ?e :diagram.settings/description :nil) '?description]]} @diag)
         (into {})
         (merge (into {} (stats))))])

(defn placed-plants []
  (d/q  {:find ['?plant '(pull ?plant [*]) '?name '(distinct ?e) '(count ?e)]
         :keys '[id plant name plants count]
         :where [['?e :diagram.object/plant-entity-id '?plant]
                 ['?plant :plant/scientific-name '?name]]} @diag))

(defn plant-types []
  (flatten (d/q  {:find ['[?type ...]]
                  :where [['?e :plant/type '?type]]} @diag)))

(defn placed-plant-eids []
  (flatten (d/q  {:find ['(pull ?plant [*])]
                  :where [['?e :diagram.object/plant-entity-id '?plant]
                          ['?plant :plant/type '?type]]} @diag)))

(defn fetch-plant [plant]
  (if (int? plant)
    (d/pull @diag '[*] plant)
    {}))

(defn fetch-plant-related
  "Given a plant eid, find other instances where it exists"
  [plant-entity-id]
  (if (int? plant-entity-id)
    (update (merge {:plant (d/pull @diag '[*] plant-entity-id)}

                   (first (d/q  {:find ['(distinct ?e) '(count ?e)]
                                 :keys '[plants count]
                                 :in '[$ ?plant-entity-id]
                                 :where [['?e :diagram.object/plant-entity-id '?plant-entity-id]
                                         ['?plant-entity-id :plant/scientific-name '?name]]} @diag plant-entity-id)))
            :plants vec)
    {}))

;(fetch-plant-related 26)

(defn fetch-plant-eid-from-uuid [uuid]
  ;; HACK for some reason the query is not accepting the param as an inline parameter
  ;; inlined to fix for now but would be nice to resolve
  (-> (d/q  '{:find [(pull ?plant [*])]
             :in [$ ?uuid]
              :where [[?plant :plant/id ?uuid]]} @diag uuid)
      first first
      (assoc :uuid uuid)))

(defn fetch-plants [plants]
  (d/pull-many '[*] plants))

(defn fetch-points
  ([] (fetch-points :diagram.object/position))
  ([attribute]
   (d/q  {:find ['?e '?pos]
          :where [['?e attribute '?pos]]} @diag)))

(defn find-nearest [xy points]
  (->> points
       (map-indexed (fn [idx points] [idx (distance xy points)]))
       (apply min-key second)))

(defn nearest-point
  ([xy] (nearest-point :diagram.object/position xy))
  ([attribute xy]
   (->>
    (fetch-points attribute)
    (map (fn [[eid points]] [eid (find-nearest xy points)]))
    (reduce (fn [a b] (if (> (second (second a)) (second (second b)))
                        b a))))))

(defn select-plant
  [type]
  (d/q  {:find ['?e '?pos '?colour '?plant]
         :keys '[entity-id points colour plant-entity-id]
         :where [['?e :diagram.object/type type]
                 ['?e :diagram.object/position '?pos]
                 ['(get-else $ ?e :diagram.object/colour "")  '?colour]
                 ['?e :diagram.object/plant-entity-id '?plant]]} @diag))

(defn select-structure [type]
  (d/q {:find ['?e '?pos '?colour '?svg-filter '?label '?plant]
        :keys '[entity-id points colour svg-filter label plant-entity-id]
        :where [['?e :diagram.object/type type]
                ['(get-else $ ?e :diagram.object/colour "")  '?colour]
                ['(get-else $ ?e :diagram.object/label "")  '?label]
                ['(get-else $ ?e :diagram.object/svg-filter "no-pattern") '?svg-filter]
                ['(get-else $ ?e :diagram.object/plant-entity-id "") '?plant]
                ;['(get-else $ ?plant :plant/type "") '?svg-filter]
                ['?e :diagram.object/position '?pos]]} @diag))

(defn rm-entity [entity-id]
  (d/transact!
   diag
   (if (vector? entity-id)
     (mapv (fn [id] [:db.fn/retractEntity id]) entity-id)
     [[:db.fn/retractEntity entity-id]])))

(defn fetch-diagram-plants []
  (-> (d/q  '{:find [(pull ?e [*])]
              :where [[?e :plant/id _]]} @diag)
            first))

(defn fetch-diagram-settings []
  (let [settings
        (-> (d/q  '{:find [(pull ?e [*])]
                    :where [[?e :diagram.settings/title ?plant]]} @diag)
            first
            last)]
    settings))


(defn set-diagram-properties [values]
  (let [diagram-id (or  (:xt/id (fetch-diagram-settings)) -1)]
    (d/transact! diag (mapv (fn update-attribs [[k v]]
                              [:db/add diagram-id k v])
                            values))))

(defn set-diagram-id [id]
  (let [diagram-id (first (d/q  '{:find [?e ?id]
                                  :where [[?e :xt/id ?id]]} @diag))]
    (prn (str "set diagram id " diagram-id))
    (prn (str "set diagram id " id))
    (if diagram-id
      (d/transact! diag [[:db/add (first diagram-id) :xt/id id] #_{:db/id (first diagram-id)
                                                                   :xt/id id}])
      #_(d/transact! diag [{:db/id (first diagram-id)
                            :xt/id id}])
      (d/transact! diag [{:xt/id id}]))))

(defn fetch-diagram-id []
  (d/q  '{:find [?id .]
          :where [[?e :xt/id ?id]]} @diag))

(defn fetch-diagram []
  (d/q  '{:find [(pull ?e [*])]
          :where [[?e :diagram.object/plant-entity-id _]]} @diag))

(defn fetch-diagram-version []
  (d/q  '{:find [?version .]
          :where [[?e :diagram/version ?version]]} @diag))

(defn fetch-diagram-eid []
  (d/q  '{:find [?e .]
          :where [[?e :diagram/version ?version]]} @diag))

(defn update-diagram-version []
  (let [version (first (d/q  '{:find [?e ?version]
                               :where [[?e :diagram/version ?version]]} @diag))]
    (d/transact! diag [{;;:xt/id (first version)
                        :diagram/version
                        (+ 1 (or (second version) 0))}])))

(defn fetch-or-create-diagram-eid []
  (let [entity (fetch-diagram-eid)]
    (when-not entity
      (d/transact! diag [{:diagram/version 1}])
      (update-diagram-version))
    (fetch-diagram-eid)))

(defn store-diagram-settings
  [diagram]

  (let [entity-id #_(fetch-diagram-eid) (-> (fetch-diagram-settings) :db/id)
        settings (namespace-map
                  :diagram.settings
                  (assoc diagram :diagram.settings/title (or (:diagram.settings/title diagram)
                                                             "Garden design")))]
    (update-diagram-version)
    (if entity-id
      (d/transact! diag [(assoc settings :db/id entity-id)])
      (d/transact! diag [settings]))
    (fetch-diagram-settings)))

(defn add-new-plant
  [plant]
  (d/transact!
   diag
   [plant #_(namespace-map :plant plant)]))

(defn add-new-diagram-object
  ([type coords] (add-new-diagram-object type coords {}))
  ([type coords data]
   (prn "add object to diagram")
   (d/transact! diag [(merge {:diagram.object/type type
                              :diagram.object/position coords}
                             data)])
   (count (select-plant type))))

(comment
  @diag
  (tap> (fetch-diagram))
  (fetch-diagram-plants)
  ;; 53
  (d/pull @diag '[*] 53)
  (d/pull @diag '[*] 14)
  (d/q  '{:find [?plant ]
          :where [[?plant :db/id 53]]} @diag)

  (d/q  '{:find [?plant ?name]
          :where [[?plant :common-name ?name]]} @diag)

  (d/q  '{:find [?plant ?name]
          :where [[?plant :diagram/title ?name]]} @diag)

  (d/q  '{:find [?plant ?name ?id]
          :where [[?plant :plant/common-name ?name]
                  [?plant :plant/id ?id]]} @diag)

  (d/q  '{:find [?e ?name]
          :where [[?e :diagram.object/plant ?plant]
                  [?plant :plant/common-name ?name]]} @diag)

  (d/q  '{:find [?e (pull ?e [*])]
          :where [[?e :diagram.object/plant ?plant]]} @diag)

  (d/q  '{:find [?e (pull ?e [*])]
          :where [[?e :diagram.settings/width ?plant]]} @diag)

  (d/q  '{:find [?e (pull ?e [*])]
          :where [[?e :diagram.object/type ?plant]]} @diag)

  (fetch-diagram-settings)
  (fetch-plants :canopy)
  (fetch-plants :sub-canopy)
  (plants)
  (set-diagram-id (parse-uuid "23b8dbc3-e5b6-4e64-9fa2-1c8e23de1734"))
  (fetch-diagram-id)
  (d/transact!
   diag
   [{:xt/id #uuid "23b8dbc3-e5b6-4e64-9fa2-1c8e23de1734"}])

  (d/q  '{:find [?e ?id]
          :where [[?e :xt/id ?id]]} @diag)

  (->> (d/datoms @diag :eavt)
       (mapv (comp vec seq))
       (mapv #(update % 1 keyword-str)))

  (d/q  '{:find [?id .]
          :where [[?e :xt/id ?id]]} @diag)

  (d/q  '{:find [(pull ?e [*])]
          :where [[?e :diagram.settings/title ?id]]} @diag)

  (d/q  '{:find [?e ?id]
          :where [[?e :xt/id ?id]]} @diag)

  (d/q  '{:find [?id .]
          :where [[?e :xt/id ?id]]} @diag)
;;(d/transact! diag [[:db.fn/retractEntity 277]])

  (set-diagram-properties
   {:xt/id (str "509e7938-3a72-4d47-a6c9-903cfe163b45") #_(str (parse-uuid (:xt/id resp)))
    :diagram.settings/title "test"
    :diagram.settings/width "200"})

  ;(update-entity)
  (placed-plants)
  (placed-plant-eids)
  (search->plants {:search #"oak"})
  (search->plants {:search #"rasp"})
  (search->plants {:type :sub-canopy})
  (search->plants {:type :herbaceous})
  (db-search-filter {:type :tree :search #"oak"})
  (d/q  {:find ['?e]
         :where [['?e :diagram.object/type]
                 ;['?e :diagram.object/position '?pos]
                 ;['(get-else $ ?e :diagram.object/colour "")  '?colour]
                 #_['?e :diagram.object/plant-entity-id '?plant]]} @diag)
  (add-new-plant
   {:id  500, :common-name "sweet chestnuts", :type :canopy, :scientific-name "Castanea sativa"})
  (fetch-diagram-settings)
  (layers)
  (stats)
  (d/e)
  (d/pull @diag '[*] 15)
  (d/pull @diag '[*] 18)
  (update-entity 112 :diagram.object/position [[100 100]])
  (fetch-diagram)
  (fetch-plant 100)
  (update-diagram-version)
  (add-new-diagram-object :canopy [10, 10])
  (add-new-diagram-object :canopy [[10, 10]] {:diagram.object/plant-entity-id 1
                                              :diagram.object/plant-uuid "b1642727-a42a-4389-8653-1304ab942639"})
  (add-new-diagram-object :canopy [10, 10] {:plant-entity-id 1})
  (select-plant :herbaceous)
  (select-plant :shrub)
  (select-plant :sub-canopy)
  (select-plant :canopy)
  (set-label 14 "Shed")
  (set-colour 14 "#880000")
  (set-colour 15 "#888888")
  (set-colour 18 "#44FF44")
  (fetch-plant-eid-from-uuid "12f796b5-6796-4eeb-ad2b-bf145ca18bfa")

(-> (d/q  '{:find [(pull ?plant [*])]
             ;;:in [$ ?uuid]
            :where [[?plant :plant/scientific-name "Castanea sativa"   ]]} @diag )
      )

  (-> (d/q  '{:find [(pull ?plant [*])]
             :in [$ ?uuid]
              :where [[?plant :plant/id ?uuid ]]} @diag "12f796b5-6796-4eeb-ad2b-bf145ca18bfa")
      )
  (add-new-plant 
   {:plant/type "canopy", :plant/lifecycle "perennials", :plant/scientific-name "Castanea sativa", :plant/id "12f796b5-6796-4eeb-ad2b-bf145ca18bfa", :plant/family "Fagaceae", :plant/common-name "sweet chestnuts", :plant/height "35m", :plant.season/fruiting {:start "october", :end "october"}, :plant/hardiness "hardy"})

  (select-plant :structure)
  (select-plant :tree))

(defn fetch-type [attrib]
  (mapv first (d/q
               {:find '[(pull ?e [*])]
                :where [['?e attrib]]} @diag)))
